import React from 'react';

const CustomTooltip = (props) => {
	return <div className="tooltipInfoBox">{props.value}</div>;
};
export default CustomTooltip;
